import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rHaritadaAra } from '../../../../api/models/rHaritadaAra';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rHaritadaAra[]>, rHaritadaAra[]>(
  ActionSubTypes.API_HARITADAARA,
  DefaultInputDataStateModel<pList, rHaritadaAra[]>()
);
